module.exports = __webpack_public_path__ + "static/media/BannerD13.cdc32404.png";